// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Reader_Class = require("../Control.Monad.Reader.Class/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Lens_Getter = require("../Data.Lens.Getter/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Effect_Aff_Bus = require("../Effect.Aff.Bus/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Ref = require("../Effect.Ref/index.js");
var Lunarbox_Api_Request = require("../Lunarbox.Api.Request/index.js");
var Lunarbox_Config = require("../Lunarbox.Config/index.js");
var Lunarbox_Control_Monad_Effect = require("../Lunarbox.Control.Monad.Effect/index.js");
var Lunarbox_Data_Profile = require("../Lunarbox.Data.Profile/index.js");
var logErrors = function (dictMonadEffect) {
    return function (input) {
        if (input instanceof Data_Either.Right) {
            return Control_Applicative.pure((dictMonadEffect.Monad0()).Applicative0())(input);
        };
        if (input instanceof Data_Either.Left) {
            return Control_Apply.applySecond(((dictMonadEffect.Monad0()).Bind1()).Apply0())(Lunarbox_Control_Monad_Effect.printString(dictMonadEffect)(input.value0))(Control_Applicative.pure((dictMonadEffect.Monad0()).Applicative0())(input));
        };
        throw new Error("Failed pattern match at Lunarbox.Api.Utils (line 26, column 19 - line 28, column 48): " + [ input.constructor.name ]);
    };
};
var mkRawRequest = function (dictMonadAff) {
    return function (dictMonadAsk) {
        return function (options) {
            return Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(Control_Monad_Reader_Class.asks(dictMonadAsk)(Data_Lens_Getter.view(Lunarbox_Config["_baseUrl"](Data_Lens_Internal_Forget.strongForget))))(function (baseUrl) {
                return Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(Lunarbox_Api_Request.requestJson(dictMonadAff)(baseUrl)(options))(function (response) {
                    return logErrors(dictMonadAff.MonadEffect0())(response);
                });
            });
        };
    };
};
var mkRequest = function (dictDecodeJson) {
    return function (dictMonadAff) {
        return function (dictMonadAsk) {
            return function (options) {
                return Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(Control_Monad_Reader_Class.asks(dictMonadAsk)(Data_Lens_Getter.view(Lunarbox_Config["_baseUrl"](Data_Lens_Internal_Forget.strongForget))))(function (baseUrl) {
                    return Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(Lunarbox_Api_Request.requestJson(dictMonadAff)(baseUrl)(options))(function (response) {
                        return logErrors(dictMonadAff.MonadEffect0())(Control_Bind.bind(Data_Either.bindEither)(response)(Data_Argonaut_Decode_Class.decodeJson(dictDecodeJson)));
                    });
                });
            };
        };
    };
};
var withBaseUrl = function (dictDecodeJson) {
    return function (dictMonadAff) {
        return function (dictMonadAsk) {
            return function (req) {
                return Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(Control_Monad_Reader_Class.asks(dictMonadAsk)(Data_Lens_Getter.view(Lunarbox_Config["_baseUrl"](Data_Lens_Internal_Forget.strongForget))))(function (baseUrl) {
                    return Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(req(baseUrl))(function (response) {
                        return logErrors(dictMonadAff.MonadEffect0())(response);
                    });
                });
            };
        };
    };
};
var authenticate = function (dictMonadAff) {
    return function (dictMonadAsk) {
        return function (req) {
            return function (fields) {
                return Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(Control_Monad_Reader_Class.asks(dictMonadAsk)(Data_Lens_Getter.view(Lunarbox_Config["_user"](Data_Lens_Internal_Forget.strongForget))))(function (v) {
                    return Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(Control_Monad_Reader_Class.asks(dictMonadAsk)(Data_Lens_Getter.view(Lunarbox_Config["_baseUrl"](Data_Lens_Internal_Forget.strongForget))))(function (baseUrl) {
                        return Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(req(baseUrl)(fields))(function (v1) {
                            if (v1 instanceof Data_Either.Left) {
                                return Control_Apply.applySecond((((dictMonadAff.MonadEffect0()).Monad0()).Bind1()).Apply0())(Lunarbox_Control_Monad_Effect.printString(dictMonadAff.MonadEffect0())(v1.value0))(Control_Applicative.pure(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())(new Data_Either.Left(v1.value0)));
                            };
                            if (v1 instanceof Data_Either.Right) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(Lunarbox_Control_Monad_Effect.print(dictMonadAff.MonadEffect0())(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                    return "isAdmin";
                                }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                    return "username";
                                }))(Data_Show.showRecordFieldsNil)(Lunarbox_Data_Profile.showUsername))(Data_Show.showBoolean)))(v1.value0))(function () {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadAff.MonadEffect0())(Effect_Ref.write(new Data_Maybe.Just(v1.value0))(v.currentUser)))(function () {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(Effect_Aff_Class.liftAff(dictMonadAff)(Effect_Aff_Bus.write(new Data_Maybe.Just(v1.value0))(v.userBus)))(function () {
                                            return Control_Applicative.pure(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())(new Data_Either.Right(v1.value0));
                                        });
                                    });
                                });
                            };
                            throw new Error("Failed pattern match at Lunarbox.Api.Utils (line 80, column 9 - line 87, column 31): " + [ v1.constructor.name ]);
                        });
                    });
                });
            };
        };
    };
};
module.exports = {
    authenticate: authenticate,
    mkRequest: mkRequest,
    withBaseUrl: withBaseUrl,
    logErrors: logErrors,
    mkRawRequest: mkRawRequest
};
